import React, { useState } from 'react';
import { Box, Button, Heading, Layer, Text, TextInput } from 'grommet';
import { Close } from 'grommet-icons';
import { CompanyService } from '@enrich/shared-lib';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const CompanyManualReportButton = ({ company }) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <Box>
            <Button
                primary
                label="Send Manual Report"
                onClick={() => setShowModal(true)}
            />
            {showModal && (
                <CompanyManualReportModal
                    company={company}
                    setShowModal={setShowModal}
                />
            )}
        </Box>
    );
};

const CompanyManualReportModal = ({ company, setShowModal }) => {
    const [email, setEmail] = useState('');
    const [buttonBusy, setButtonBusy] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const isValidEmail = EMAIL_REGEX.test(email);

    const createReport = async () => {
        setErrorMessage('');
        setButtonBusy(true);
        try {
            await new CompanyService().sendReport(company.id, email);
            setShowModal(false);
        } catch (error) {
            console.log(error);
            setErrorMessage(
                error.response?.data?.error?.message ||
                    error.message ||
                    'Failed to send report. Please try again.',
            );
            setButtonBusy(false);
        }
    };

    return (
        <Layer
            onClickOutside={() => setShowModal(false)}
            onEsc={() => setShowModal(false)}
            position="center">
            <Box
                background="white"
                pad="medium"
                round="6px"
                border={{ color: 'enrich-green-light', size: '3px' }}
                alignSelf="center"
                gap="20px">
                <Box direction="row" gap="20px" justify="between">
                    <Heading level="3" margin={{ vertical: 'none' }}>
                        Send manual report for {company.attributes.name}
                    </Heading>
                    <Box align="end">
                        <Close
                            onClick={() => setShowModal(false)}
                            cursor="pointer"
                        />
                    </Box>
                </Box>
                <Box>
                    <Box
                        width="medium"
                        align="center"
                        round="6px"
                        background="white">
                        <TextInput
                            onChange={(event) => setEmail(event.target.value)}
                            placeholder="Email"
                            value={email}
                            type="email"
                        />
                    </Box>
                </Box>
                {errorMessage && (
                    <Box>
                        <Text color="red">{errorMessage}</Text>
                    </Box>
                )}
                <Box>
                    <Button
                        primary
                        busy={buttonBusy}
                        disabled={!isValidEmail || buttonBusy}
                        label="Send email report"
                        style={{ width: '220px', height: '50px' }}
                        alignSelf="center"
                        onClick={createReport}
                    />
                </Box>
            </Box>
        </Layer>
    );
};
